<template>
  <div class="view projects" v-if="projects">
    <div class="projects-header">
      <div class="title">{{ $t("my_projects") }}</div>
      <div class="view-options">
        
        <!-- <div class="separator" v-if="hasProjects"></div> -->
        <!--<div class="view-mode filter"></div>-->
        <div class="separator" v-if="hasProjects"></div>
        <multi-select-component
          mode="single"
          v-model="statusFilterValue"
          :label="$t('show_projects')"
          :options="statusFilterOptions"
          v-if="hasProjects"
          :configurationOptions="{ 'allow-empty': false, 'label-inside': true }"
        />
        <multi-select-component
          mode="single"
          v-model="sortingValue"
          :label="$t('sort_by')"
          :options="sortingOptions"
          v-if="hasProjects"
          :configurationOptions="{ 'allow-empty': false, 'label-inside': true }"
        />
        <div
          v-if="hasProjects"
          class="sort-arrow down"
          :class="sortingDirection === 'down' ? 'selected' : 'unselected'"
          @click="sortingDirection = 'down'"
        ></div>
        <div
          v-if="hasProjects"
          class="sort-arrow up"
          :class="sortingDirection === 'up' ? 'selected' : 'unselected'"
          @click="sortingDirection = 'up'"
        ></div>
        <div
          class="view-mode"
          :class="[viewMode]"
          @click="changeViewMode"
          v-if="hasProjects"
        ></div>
        <div class="separator"></div>
        <div class="btn btn--secondary btn-new-project" @click="newProjectModal">
          {{ $t("new_project") }}
        </div>
      </div>
    </div>
    <template v-if="sortedProjects.length > 0">
      <div class="projects-container">
        <img class="background-image" src="~@/assets/background_image.png">
        <div v-if="viewMode === 'grid'" class="grid">
          <project-card
            v-for="project in sortedProjects"
            :key="project.id"
            :project="project"
          ></project-card>
        </div>
        <div v-if="viewMode === 'list'" class="list">
          <project-list-item
            v-for="project in sortedProjects"
            :key="project.id"
            :project="project"
          ></project-list-item>
        </div>
    </div>
    </template>
    <template v-else>
      <div class="no-projects">
        {{$t('no_projects')}}
      </div>
    </template>
    <modal-create-new name="new-project-modal" type="project"></modal-create-new>
  </div>
  <div class="view" v-else>
    <loading-overlay></loading-overlay>
  </div>
</template>

<script>
import Api from '@/api'
import ProjectCard from '@/components/project/ProjectCard'
import ProjectListItem from '@/components/project/ProjectListItem'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import ModalCreateNew from '@/components/modals/ModalCreateNew'

const STATUS_SORTING_ORDER = [ 'draft', 'ongoing', 'closed']
export default {
  name: 'ProjectsView',
  components: {ProjectCard, ProjectListItem, MultiSelectComponent, ModalCreateNew},
  data () {
    return {
      sortingDirection: 'down',
      sortingValue: 'creationTimestamp',
      sortingOptions: [
        { label: 'Date', value: 'creationTimestamp' },
        { label: 'Status', value: 'status' },
        { label: 'Number of trials', value: 'numberOfTrials' }
      ],
      statusFilterValue: 'active',
      statusFilterOptions: [
        { label: 'Active', value: 'active'},
        { label: 'Archived',value: 'archived'}
      ],
      viewMode: 'grid'
    }
  },
  asyncComputed: {
    projects () {
      return this.$store.state.projects.data || this.$store.dispatch('projects/load')
    },
  },
  methods: {
    setViewMode (mode) {
      if (mode !== this.viewMode) {
        return this.viewMode = mode
      }
    },
    changeViewMode () {
      console.log(this.viewMode)
      if (this.viewMode === 'grid') {
        this.viewMode = 'list'
      } else {
        this.viewMode = 'grid'
      }
    },
    sortingFcn (a,b) {
      let ascOrder = a - b
      if (this.sortingValue === 'creationTimestamp') {
        if (a.creationTimestamp < b.creationTimestamp) {
          ascOrder = 1
        } else if (a.creationTimestamp > b.creationTimestamp){
          ascOrder = -1
        } else {
          ascOrder = 0
        }
      } else if (this.sortingValue === 'status') {
        ascOrder = STATUS_SORTING_ORDER.findIndex(s => s === a[this.sortingValue]) - STATUS_SORTING_ORDER.findIndex(s => s === b[this.sortingValue])
      } else if (this.sortingValue === 'numberOfTrials') {
        ascOrder = b.trials.length - a.trials.length 
      }
      if (ascOrder === 0) { // perque lordre sigui alfabetic del nom en cas d'empat
        ascOrder = a.name < b.name ? -1:1
      }
      if (this.sortingDirection === 'down') return ascOrder
      return - ascOrder
    },

    newProjectModal() {
      this.$modal.show('new-project-modal')
    }
  },
  computed: {
    sortedProjects () {
      let filtered = (this.projects || []).filter((p)=>{
        if(this.statusFilterValue==='active') return p.status !== 'archived'
        else return p.status === 'archived'
      })
      return filtered.sort((a, b) => this.sortingFcn(a, b))
    },
    hasProjects () {
      return this.projects.length > 0
    }
  }
}
</script>

<style lang="stylus" scoped>
.projects
  display: flex
  flex-direction: column

  >>> .vm--modal
    border-radius: 10px
    height: auto !important
    max-height: 50% !important

  .separator
    background-color: #fff
    height: 20px
    margin-left: 10px
    margin-right: 10px
    width: 1px

  .projects-header
    align-items: center
    border-bottom: 1px solid #fff
    display: flex
    flex: 0 0 50px
    m-font-size(20, 24)
    padding-left: 90px
    padding-right: 90px
    +m-breakpoint(sm md)
      padding-left: 15px
      padding-right: 15px
    .title
      color: $shark
      m-font-size(20, 25)
      +m-breakpoint(sm md)
        display none

    .view-options
      align-items: center
      display: flex
      margin-left: auto

      .view-mode
        cursor: pointer
        +m-breakpoint(sm md)
          display none
        // &:not(.filter)
        // opacity: 0.5

        // &:hover
        // &:not(.active)
        // &:not(.filter)
        // opacity: 0.75

        // &.active
        // &:not(.filter)
        // cursor: default
        // opacity: 1
        &.list
          m-icon("grid-view", 17)

        &.grid
          m-icon("list-view", 18 17)

        &.filter
          m-icon("filter", 18)

      .multi-select-component
        margin-right: 5px
        width: 150px

      .sort-arrow
        m-icon("arrow", 15)
        transition: transform 0.25s ease-in-out

        &:not(:last-child)
          margin-right: 5px

        &.up
          transform: rotate(180deg)

        &.unselected
          opacity: 0.3

          &:hover
            cursor: pointer
            opacity: 1
    .btn-new-project
      +m-breakpoint(sm md)
        display none
  .no-projects
    text-align center
    m-font-size(18)
    font-weight $fw-semi-bold
    margin-top 50px
  .projects-container

    .background-image
      opacity: 1
      position: absolute
      width: 100%
      height: auto
    .grid
      display: flex
      flex: 1 1 0%
      flex-wrap: wrap
      overflow-y: auto
      margin-top: 20px
      padding-bottom: 10px
      padding-left: 80px
      padding-right: 80px
      +m-breakpoint(sm md)
        padding-left: 15px
        padding-right: 15px
      .project-card
        $number-of-columns = 4
        $percentage = percentage((1 / $number-of-columns))
        $margin = 10px
        $width = "calc(%s - %s * 2)" % ($percentage $margin)
        flex: 0 0 $width
        margin: $margin
        +m-breakpoint(sm md)
          $number-of-columns = 2
          $percentage = percentage((1 / $number-of-columns))
          $margin = 10px
          $width = "calc(%s - %s * 2)" % ($percentage $margin)
          flex: 0 0 $width
          margin: $margin
        +m-breakpoint(md xxmd)
          $number-of-columns = 3
          $percentage = percentage((1 / $number-of-columns))
          $margin = 10px
          $width = "calc(%s - %s * 2)" % ($percentage $margin)
          flex: 0 0 $width
          margin: $margin
        

    .list
      display: flex
      flex: 1 1 0%
      flex-direction: column
      overflow-y: auto
      margin-top: 20px

      >>> .project-card-expanded-trials
        .trial
          border-bottom: 1px solid $heather
</style>